import { render } from "./quick-page.vue?vue&type=template&id=ba4b6248&scoped=true"
import script from "./quick-page.vue?vue&type=script&lang=js"
export * from "./quick-page.vue?vue&type=script&lang=js"

import "./quick-page.vue?vue&type=style&index=0&id=ba4b6248&scoped=true&lang=scss"

import exportComponent from "/Users/xujunfeng/Desktop/project/school/digital_factory_server/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4b6248"]])

export default __exports__